import API from "../axiosConfig";

export const getAllRoles = async () => {
  try {
    const response = await API.get("roles");
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getRole = async (id) => {
  try {
    const response = await API.get(`roles/${id}`);
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Create a new role
 */
export const createRole = async (roleData) => {
  try {
    const response = await API.post("roles", roleData);
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Update a role
 */
export const updateRole = async (id, roleData) => {
  try {
    const response = await API.put(`roles/${id}`, roleData);
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Delete a role
 */
export const deleteRole = async (id) => {
  try {
    const response = await API.delete(`roles/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};


// roles-names
export const getRolesNames = async () => {
  try {
    const response = await API.get("roles-names");
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};